/**
 * @file 模块化 mathjax
 * @author wanzhongyun
 */
import './style.less';

const mathJaxPromise = new Promise<any>((resolve, reject) => {
    (window as any).mathjaxonload = () => {
        resolve((window as any).MathJax);
        delete (window as any).mathjaxonload;
    };
});

const head = document.getElementsByTagName('head')[0];

const script = document.createElement('script');
script.type = 'text/x-mathjax-config';

script[((window as any).opera ? 'innerHTML' : 'text')] = `
MathJax.Hub.Config({
  tex2jax: { inlineMath: [['$','$'], ['\\\\(','\\\\)']] },
  skipTags: ['script', 'noscript', 'style', 'textarea', 'pre','code','a']
});
window.mathjaxonload();
`;
head.appendChild(script);

const script2 = document.createElement('script');
script2.type = 'text/javascript';
script2.src = 'https://paddlepaddle-cloudflare.cdn.bcebos.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS-MML_HTMLorMML';
// 增加200毫秒延迟让 mathJax 加载和页面内容加载错开
setTimeout(() => {
    head.appendChild(script2);
}, 200);

export default mathJaxPromise;
